<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="order-box">
    <s-header :name="'我的订单'" :back="'/user'"></s-header>
    <div class="message" v-if="isVisitor" @click="bindEnterInfo">
      如需使用实时订单开票功能，请先完善企业信息！<van-button
        type="primary"
        size="mini"
        >去完善</van-button
      >
    </div>
    <van-tabs
      @click="onChangeTab"
      :color="'#40c6ff'"
      :title-active-color="'#40c6ff'"
      class="order-tab"
      v-model:active="status"
    >
      <van-tab title="全部" name=""></van-tab>
      <van-tab title="待付款" name="0"></van-tab>
      <van-tab title="待确认" name="1"></van-tab>
      <van-tab title="待发货" name="2"></van-tab>
      <van-tab title="已发货" name="3"></van-tab>
      <van-tab title="交易完成" name="4"></van-tab>
    </van-tabs>
    <div class="content">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        class="order-list-refresh"
      >
        <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          @offset="10"
        >
          <div
            v-for="(item, index) in list"
            :key="index"
            class="order-item-box"
            @click="goTo(item.orderNo)"
          >
            <div class="order-item-header">
              <span>订单时间：{{ item.createTime }}</span>
              <span>{{ item.orderStatusString }}</span>
            </div>
            <van-card
              v-for="one in item.newBeeMallOrderItemVOS"
              :key="one.orderId"
              :num="one.goodsCount"
              :price="one.payPrice + '.00'"
              :origin-price="
                one.sellingPrice > one.payPrice ? one.sellingPrice : none
              "
              :desc="one.collection"
              :title="one.goodsName"
              :thumb="$filters.prefix(one.goodsCoverImg)"
            />
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { ref, reactive, toRefs, onMounted } from 'vue'
import sHeader from '@/components/SimpleHeader'
import { getOrderList } from '@/service/order'
import { useRouter, useRoute } from 'vue-router'
// import { getLocal } from '@/common/js/utils'
import { getUserInfo } from '@/service/user'
export default {
  name: 'Order',
  components: {
    sHeader
  },

  setup() {
    const route = useRoute()
    const { name } = route.query
    const router = useRouter()
    const status = ref('')
    const state = reactive({
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      page: 1,
      totalPage: 0,
      user: {},
      isVisitor: false // 标记是否为游客身份
    })
    onMounted(() => {
      init()
      state.status = name
      onRefresh()
    })
    const init = async () => {
      /* const userData = JSON.parse(getLocal('userData'))
      if(userData.companyName === '') { // 游客模式
        state.isVisitor = true
      } */
      const { data } = await getUserInfo()
      state.user = data
      if (state.user.isVisitor === 0) {
        //0.不完善 1.已完善
        state.isVisitor = true
      }
    }
    const loadData = async () => {
      const {
        data,
        data: { list }
      } = await getOrderList({ pageNumber: state.page, status: state.status })
      state.list = state.list.concat(list)
      state.totalPage = data.totalPage
      state.loading = false
      if (state.page >= data.totalPage) state.finished = true
    }

    const onChangeTab = (name) => {
      // 这里 Tab 最好采用点击事件，@click，如果用 @change 事件，会默认进来执行一次。
      state.status = name
      onRefresh()
    }

    const goTo = (id) => {
      router.push({ path: '/order-detail', query: { id } })
    }

    const goBack = () => {
      router.go(-1)
    }

    const onLoad = () => {
      console.log('111');
      if (!state.refreshing && state.page < state.totalPage) {
        state.page = state.page + 1
      }
      if (state.refreshing) {
        state.list = []
        state.refreshing = false
      }
      loadData()
    }

    const onRefresh = () => {
      state.refreshing = true
      state.finished = false
      state.loading = true
      state.page = 1
      onLoad()
    }

    const bindEnterInfo = () => {
      window.wx.miniProgram.navigateTo({
        url: '/pages/contactInfo/contactInfo'
      })
    }
    return {
      ...toRefs(state),
      init,
      onChangeTab,
      goTo,
      goBack,
      onLoad,
      status,
      onRefresh,
      bindEnterInfo
    }
  }
}
</script>

<style lang="less" >
@import '../common/style/mixin';
.van-card__content {
  justify-content: space-around!important;
}
.van-ellipsis {
  margin-top: 10px;
}
.order-box {
  .message {
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-top: 5px;
    padding: 0 10px;
    span {
      color: rgb(64, 198, 255);
    }
  }
  .order-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .fj();
    .wh(100%, 44px);
    line-height: 44px;
    padding: 0 10px;
    .boxSizing();
    color: #252525;
    background: #fff;
    border-bottom: 1px solid #dcdcdc;
    .order-name {
      font-size: 14px;
    }
  }
  .order-tab {
    position: fixed;
    left: 0;
    z-index: 1000;
    width: 100%;
    border-bottom: 1px solid #e9e9e9;
  }
  .skeleton {
    margin-top: 60px;
  }
  .content {
    height: calc(~'(100vh - 70px)');
    overflow: hidden;
    overflow-y: scroll;
    margin-top: 34px;
  }
    .van-card__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .van-pull-refresh__head {
      background: #f9f9f9;
    }
    .order-item-box {
      margin: 20px 10px;
      background-color: #fff;
      .order-item-header {
        padding: 10px 20px 0 20px;
        display: flex;
        justify-content: space-between;
      }
      .van-card {
        background-color: #fff;
        margin-top: 0;
      }
    }
}
</style>
